export const Spacing = {
  XS: 4,
  S: 6,
  M: 16,
  L: 20,
  XL: 30,
  XXL: 40,
};
